import { Controller } from "stimulus"

// Bugfix 16 (#1351): de navigatie van het sporterprofiel schuift horizontaal
// als hij niet past (tablet). Houd de actieve sectie dan in beeld, ook na een
// wissel via het sectieframe of na verversen.
export default class extends Controller {
  static targets = ["list"]

  connect() {
    const active = this.element.querySelector("[aria-current='page']")
    if (!active || !this.hasListTarget) return

    const list = this.listTarget
    const left = active.offsetLeft - list.offsetLeft
    const right = left + active.offsetWidth
    if (left < list.scrollLeft || right > list.scrollLeft + list.clientWidth) {
      list.scrollLeft = Math.max(0, left - (list.clientWidth - active.offsetWidth) / 2)
    }
  }
}
